import scrollToElement from 'helpers/scroll/scrollTo';

const scrollToAnchors = (function () {
    const _addClickEventListeners = () => {
        const anchors = document.querySelectorAll('.anchor-link');

        if (anchors.length) {
            anchors.forEach((anchor) => {
                anchor.addEventListener('click', () => {
                    const scrollTarget = anchor.getAttribute('href');
                    scrollToElement(scrollTarget, true);
                });
            });
        }
    };

    const init = () => {
        _addClickEventListeners();
    };

    return {
        init
    };
})();

scrollToAnchors.init();
